import { invoiceActionStatus } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import {
  useGetOpenIncidentDashboardCount,
  useGetOwnerDashboardParkedStatus,
} from "@/services";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useCriticalActionSection = () => {
  const navigate = useNavigate();
  const { communityData, currentFinanceYear } = useSelector(
    (state: RootState) => state.currentData
  );

  const { data: parkedStatus, isLoading: isParkedStatus } =
    useGetOwnerDashboardParkedStatus({
      communityId: communityData?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityData?.communityId && currentFinanceYear),
      },
    });

  const { data: openIncident, isLoading: isOpenIncidentLoading } =
    useGetOpenIncidentDashboardCount({
      communityId: communityData?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityData?.communityId && currentFinanceYear),
      },
    });

  const onInvoiceAwaitingClick = () => {
    navigate(
      `${routes.invoice}/${invoiceActionStatus.pending_for_cam_approval}`
    );
  };

  const onViewIncident = () => {
    navigate(`/${routes.cam}/${routes.incidentMgmt}`);
  };

  return {
    onInvoiceAwaitingClick,
    parkedStatus,
    isParkedStatus,
    isOpenIncidentLoading,
    openIncident,
    onViewIncident,
  };
};

export default useCriticalActionSection;
